import { Text } from '@zillow/constellation-10';

export const SmallDropzone = ({ displayText }: { displayText?: string }) => (
  <Text css={{ marginTop: 'tight', whiteSpace: 'pre-line' }}>{displayText ?? 'Add'}</Text>
);
